(function () {
    'use strict';

    angular
        .module('Lavpop-store.components')
        .controller('OrdersController', OrdersController);

    /** @ngInject */
    function OrdersController($scope, $q, $rootScope, $httpParamSerializer, HelperService, OrderService, AuthenticationService, DATA_EVENTS, ROUTES, ReportDownloadService) {
        const vm = this;
        let isTableSearch = false;
        let forcePaginationReset = false;
        let authSelectedUnit;

        var removeWatchUnits = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            init(true);
        })

        $scope.$on('$destroy', () => {
            removeWatchUnits();
        })

        vm.isSearchDisabled = () => {
            if (vm.selectedStatus || vm.datePicker.date.startDate || (vm.selectedSearchField && vm.searchText))
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedStatus || vm.datePicker.date.startDate || vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if ((event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;
                vm.isLoading = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedStatus = null;
            vm.datePicker.date.startDate = null;
            vm.datePicker.date.endDate = null;
            vm.selectedSearchField = null;
            vm.searchText = null;

            if (isTableSearch)
                vm.tableCallServer();

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getOrders(start, number, tableState);
        }

        vm.onChangeUnit = () => {
            const currentSelectedUnit = AuthenticationService.getSelectedUnit();

            if (vm.selectedUnit.Id && vm.selectedUnit.Id != currentSelectedUnit.Id) {
                AuthenticationService
                    .setUnit(vm.selectedUnit.Id)
                    .then(response => {
                        authSelectedUnit = vm.selectedUnit;

                        $rootScope.$broadcast(DATA_EVENTS.SELECTED_UNIT_CHANGE);

                        if (response.error)
                            HelperService.handleStateChangeError(response);
                    }, error => {
                        $rootScope.$broadcast(DATA_EVENTS.SELECTED_UNIT_CHANGE);

                        HelperService.handleStateChangeError(error);
                    })
            }
        }

        vm.configureReportDownload = () => {
            const parameters = prepareReportParameters();

            return ReportDownloadService.download('orders-report-detailed', parameters);
        }

        init();

        function getOrders(start, number, tableState) {
            let params = prepareParameters(start, number, tableState);

            OrderService
                .getAllByParameters(params)
                .then(
                    success => {
                        vm.orders = success.Orders;
                        tableState.pagination.numberOfPages = success.NumberOfPages;

                        vm.isLoading = false;
                    },
                                        error => {
                        vm.isLoading = false;
                        HelperService.errorCallback(error);
                    }
                )
        }

        function getStatus() {
            return OrderService
                .getAllStatus()
                .then(success => {
                    vm.status = success;

                    vm.status = vm.status.reduce((acc, cur) => {
                        cur.Description = cur.Description.replace(/([A-Z])/g, ' $1')
                        acc.push(cur);

                        return acc;
                    }, [])
                }, error => HelperService.errorCallback(error))
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'RegistrationDate',
                OrderDescending: true,
                PersonId: AuthenticationService.getUserId(),
                UnitId: authSelectedUnit.Id
            }

            if (tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText) {
                params.SearchField = vm.selectedSearchField.Value;
                params.SearchQuery = vm.searchText;
                isTableSearch = true;
            }

            if (vm.selectedStatus) {
                params.OrderStatusId = vm.selectedStatus.Id;
                isTableSearch = true;
            }

            if (vm.datePicker.date.startDate) {
                params.StartDate = vm.datePicker.date.startDate.format('YYYY-MM-DD');
                params.EndDate = vm.datePicker.date.endDate.format('YYYY-MM-DD');
                isTableSearch = true;
            }

            return params;
        }

        function prepareReportParameters() {
            const userData = AuthenticationService.getUserData();

            let params = {
                UnitId: authSelectedUnit.Id
            };

            if (vm.selectedSearchField && vm.searchText) {
                params.SearchField = vm.selectedSearchField.Value;
                params.SearchQuery = vm.searchText;
            }

            if (vm.selectedStatus)
                params.OrderStatusId = vm.selectedStatus.Id;

            if (vm.datePicker.date.startDate) {
                params.StartDate = vm.datePicker.date.startDate.format('YYYY-MM-DD');
                params.EndDate = vm.datePicker.date.endDate.format('YYYY-MM-DD');
            }

            if (userData.Person_Unit.AccessLevelId == 5 && userData.Person_Unit.ResponsibilityId == 8) {
                let personProvider = userData.Person_Provider ? userData.Person_Provider.ProviderId : 0;

                params.ProviderId = personProvider;
            }

            return params;
        }

        function init(loadOrders = false) {
            $rootScope.addDivisor = true;

            vm.isLoading = true;
            vm.orders = [];

            vm.selectedSearchField;
            vm.searchText;

            vm.units = AuthenticationService.getUnits();
            authSelectedUnit = AuthenticationService.getSelectedUnit();

            let foundUnit = vm.units.find(unit => (unit.Id == authSelectedUnit.Id));

            if (foundUnit)
                vm.selectedUnit = foundUnit;

            if (loadOrders)
                vm.tableCallServer();

            vm.datePicker = {
                date: {
                    startDate: moment().subtract(7, 'days'),
                    endDate: moment()
                },
                options: {
                    'opens': 'left',
                    'maxDate': moment(),
                    'timePicker': false,
                    'format': 'DD/MM/YYYY',
                    'ranges': {
                        'Hoje': [
                            moment(),
                            moment()
                        ],
                        'Ontem': [
                            moment().subtract(1, 'days'),
                            moment().subtract(1, 'days')
                        ],
                        '7 Dias': [
                            moment().subtract(7, 'days'),
                            moment()
                        ],
                        '15 Dias': [
                            moment().subtract(15, 'days'),
                            moment()
                        ],
                        '30 Dias': [
                            moment().subtract(30, 'days'),
                            moment()
                        ]
                    }
                }
            };

            vm.searchFields = [{
                Value: 'Id',
                Description: 'Código do Pedido'
            }];

            HelperService.startLoading('.cart-holder');

            $q.all([getStatus()])
                .then(() => {
                    HelperService.stopLoading('.cart-holder');
                })
        }
    }
}());